import { fetchAllChannels } from '@api/services/titles';
import useLoad, { LoadOptions } from '@hooks/useLoad';
import { Country } from '@models/CountriesAndLanguages';
import { GetAllChannelsDTO } from '@models/Epg';
import { stringComparator } from '@utils/arrayUtils';

const sortChannels = (channels?: GetAllChannelsDTO) =>
  channels
    ? {
        ...channels,
        data: channels?.data.sort((a, b) => stringComparator(a.value.name, b.value.name)),
      }
    : undefined;

const useChannelsQuery = (country?: Country, options?: LoadOptions<GetAllChannelsDTO>) =>
  useLoad(() => fetchAllChannels(country), ['channels'], {
    dataTransformer: sortChannels,
    ...options,
  });

export default useChannelsQuery;
